const faqConstants = {
  GET_ALL_FAQ_REQUEST: 'GET_ALL_FAQ_REQUEST',
  GET_ALL_FAQ_SUCCESS: 'GET_ALL_FAQ_SUCCESS',
  GET_ALL_FAQ_FAILURE: 'GET_ALL_FAQ_FAILURE',
};

export default faqConstants;
